import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GoogleTagManagerService } from 'angular-google-tag-manager';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'front-venta-verde';

  constructor(
    public translate: TranslateService, private gtmService: GoogleTagManagerService
  ) {
    translate.addLangs(["pt", "es", "en"]);
    translate.setDefaultLang("es");
    const browserLang = translate.getBrowserLang();
    translate.use(browserLang.match(/es|pt|en/) ? browserLang : 'es')

    this.gtmService.addGtmToDom();
  }

}
